$(function () {

	function setHeight() {
		var vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setHeight();

	var isAboutPage = $('.js_aboutBox').length > 0;

	// $(window).on('load', function () {
	// 	var navi = $('.naviIcon');
	// 	navi.removeClass('active');
	// });


	// $(window).scroll(function () {
	// 	if ($(this).scrollTop() > 100) {
	// 		console.log('scroll');
	// 	} else {
	// 		setTimeout(function () {
	// 			console.log('stop');
	// 		}, 1000);

	// 	}
	// });


	// cookie
	if ($.cookie('scenario') != 'isView') {
		console.log("nocookie");
		$.cookie('scenario', 'isView');
	} else {
		console.log("cookie");
		$('.splash').addClass('hidden');
		$('.wrapper--top').addClass('viewed');
		$.cookie('scenario', 'isView');
	}


	// var navi = $('.naviIcon');
	// var navi_top = $('.header');
	// //スクロールしてページトップから100に達したらクラスを付与する
	// $(window).on('load scroll', function () {

	// 	if ($(this).scrollTop() > 100) {
	// 		navi.addClass('active');
	// 		navi_top.addClass('active');
	// 	} else {

	// 		navi.removeClass('active');
	// 		navi_top.removeClass('active');

	// 	}
	// });


	// var startPos = 0, winScrollTop = 0;
	// $(window).on('scroll', function () {
	// 	winScrollTop = $(this).scrollTop();
	// 	if (winScrollTop >= startPos) {
	// 		$('.naviIcon').removeClass('active');
	// 		$('.header').removeClass('active');
	// 	} else {
	// 		$('.naviIcon').addClass('active');
	// 		$('.header').addClass('active');
	// 	}
	// 	startPos = winScrollTop;
	// });


	// $(".outerSite").colorbox({
	// 	iframe: true,
	// 	width: "80%",
	// 	height: "80%",
	// 	opacity: 0.7
	// });

	$('.outerSite').magnificPopup({
		type: 'iframe',
		// removalDelay: 500
	});

	$('.popup-image').magnificPopup({
		type: 'image',
		// removalDelay: 500,
	});

	$('.popup-modal').magnificPopup({
		type: 'inline',
		// removalDelay: 500,
		// preloader: false
	});

	$('.outerSite').on('click', function () {
		$('body').addClass('popup');
	});



	//閉じるリンクの設定
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	// $('.naviIcon').on({
	// 	'mouseenter': function () {
	// 		$(this).addClass('active2');
	// 	},
	// 	'mouseleave': function () {
	// 		$(this).removeClass('active');
	// 		$(this).removeClass('active2');
	// 	}
	// })


	$('.productSlider__list').slick({
		autoplay: false,
		arrows: false,
		dots: true,
		infinite: false,
		variableWidth: true,
		centerPadding: '50px',
		responsive: [
			{
				breakpoint: 480,
				settings: {
					centerMode: true,
					centerPadding: '20px'
				}
			}
		]
	});

	$('.productDetailSlider__list').slick({
		autoplay: false,
		arrows: false,
		dots: true,
		infinite: false
	});

	$('.layoutSwitch__listItem').on('click', function () {
		const btnSelected = $(this).hasClass('swOn');
		const btnNotSelected = $(this).not('swOn');
		const chgLayoutClass = $('.businessSection__list');
		const hasLineContent = $(this).hasClass('layoutSwitch__listItem--line');
		const hasBoxContent = $(this).hasClass('layoutSwitch__listItem--box');

		console.log(btnSelected);

		$('.layoutSwitch__listItem').removeClass('swOn');

		if (btnNotSelected) {
			$(this).addClass('swOn');
		}

		if (hasLineContent) {
			chgLayoutClass.removeClass('boxLayout');
			chgLayoutClass.find('*').removeClass('boxLayout');
		}

		if (hasBoxContent) {
			chgLayoutClass.addClass('boxLayout');
			chgLayoutClass.find('*').addClass('boxLayout');
		}

	});



	var movefun = function (event) {
		event.preventDefault();
	}

	$('.header__menuBtn').on('click', function () {
		if ($(window).width() < 480) {
			var scrl = $(window).scrollTop();
			$('body').addClass('menuOn');
			$('.header,.content,.headerNavi').addClass('menuSlide');
			$('.header').removeClass('active');
			window.addEventListener('touchmove', movefun, { passive: false });
		} else {
			$('.headerNavi').addClass('showMenu');
		}

	});

	$('.headerNavi__close').on('click', function () {
		if ($(window).width() < 480) {
			var scrl = $(window).scrollTop();
			$('.header,.content,.headerNavi').removeClass('menuSlide');
			$('body').removeClass('menuOn');
			window.removeEventListener('touchmove', movefun, { passive: false });
		} else {
			$('.headerNavi').removeClass('showMenu');
		}
	});

	$('.toTop__wrap').on('click', function () {
		setTimeout(function () {
			var $body = $(document.scrollingElement);
			if (isAboutPage) {
				$body = $('#aboutContent');
			}
			$body.animate({ scrollTop: 0 }, 500, function () {
				$("#toggle").prop("checked", false);
			});
		}, 500);
	});


	$(window).on('load scroll', function () {
		$('.count').each(function () {
			var position = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > position - windowHeight + 150) {

				//数字カウンター
				var countElm = $('.count'),
					countSpeed = 5;

				countElm.each(function () {
					var self = $(this),
						countMax = self.attr('data-num'),
						thisCount = self.text(),
						countTimer;

					function timer() {
						countTimer = setInterval(function () {
							var countNext = thisCount++;
							self.text(countNext);

							if (countNext == countMax) {
								clearInterval(countTimer);
							}
						}, countSpeed);
					}
					timer();
				});
			}
		});
	});


});




const sections = document.querySelectorAll('.js_section');
// const changeSectionHeight = () => {
// 	for (let i = 0; i < sections.length; i++) {
// 		const _inner = sections[i].querySelector('.js_sectionInner');
// 		sections[i].style.height = _inner.offsetHeight + 'px';
// 	}
// };
// changeSectionHeight();
// window.addEventListener('load', changeSectionHeight, false);
// window.addEventListener('resize', changeSectionHeight, false);

const sectionScroll = () => {
	for (let i = 0; i < sections.length; i++) {
		const currentSection = sections[i];
		const _next = currentSection.nextElementSibling;
		const _textElms = currentSection.querySelectorAll('.js_moveText');
		const rect = currentSection.getBoundingClientRect();
		if (rect.bottom - window.innerHeight <= 0) {
			if (!currentSection.classList.contains('stop')) {
				currentSection.classList.add('stop');
				_next.classList.add('start');
			}
		} else {
			if (currentSection.classList.contains('stop')) {
				currentSection.classList.remove('stop');
				_next.classList.remove('start');
			}
		}

		if (_textElms.length > 0) {
			const diff = rect.bottom - window.innerHeight;
			for (let i = 0; i < _textElms.length; i++) {
				_textElms[i].style.transform = 'translateX(' + diff + 'px)';
			}
		}
	}
};
window.addEventListener('scroll', sectionScroll, false);
